/* MD Producto compra: sincroniza precio, referencia y stock al cambiar de talla y abre la guía de tallas */
(function () {
  'use strict';

  var ROOT = '.md-producto-compra';

  /*
    Cambio de talla: el <variant-picker> del tema (dentro de esta sección) emite el evento estándar
    "product:select" con una promesa (event.promise) que se resuelve con { detail: { html, productId,
    resource } } cuando llega la respuesta del servidor; "html" es la ficha completa renderizada con
    la nueva variante. El formulario de compra del tema ya actualiza el botón y la cantidad con ese
    mismo HTML; aquí se hace lo propio con las zonas marcadas con data-md-sync (precio, referencia y
    stock), sustituyendo cada nodo por su versión recién renderizada.
  */
  var VARIANT_EVENT = 'shopify:product:select';

  /* Limpieza por instancia para el evento unload del editor */
  var cleanups = new WeakMap();

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    var sectionId = container.dataset.sectionId || '';
    var productId = container.dataset.productId || '';

    function syncFromHtml(html) {
      var fresh = html.querySelector(ROOT + '[data-section-id="' + sectionId + '"]');
      if (!fresh) return;

      var regions = container.querySelectorAll('[data-md-sync]');
      for (var i = 0; i < regions.length; i++) {
        var key = regions[i].dataset.mdSync;
        var next = fresh.querySelector('[data-md-sync="' + key + '"]');
        if (next) regions[i].replaceWith(document.importNode(next, true));
      }
    }

    function onProductSelect(e) {
      if (!e.promise || typeof e.promise.then !== 'function') return;

      e.promise.then(function (result) {
        var detail = result && result.detail;
        if (!detail || !detail.html) return;
        if (detail.productId && String(detail.productId) !== productId) return;
        syncFromHtml(detail.html);
        /* URL con la variante elegida (enlaces compartibles y recarga en la misma talla) */
        var variante = detail.resource && detail.resource.id;
        if (variante && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            if (url.searchParams.get('variant') !== String(variante)) {
              url.searchParams.set('variant', String(variante));
              window.history.replaceState({}, '', url.toString());
            }
          } catch (err) {
            /* URL no modificable: sin consecuencias */
          }
        }
      }).catch(function () {
        /* Petición cancelada por otra selección más reciente: no hay nada que actualizar */
      });
    }

    /* El evento burbujea desde el selector de tallas hasta la raíz de la sección */
    container.addEventListener(VARIANT_EVENT, onProductSelect);

    /*
      Guía de tallas: si la última imagen del producto es la tabla de tallas, se abre en el visor
      ampliado de la galería (md-producto-galeria), que vive en otra sección y se localiza por el id
      del producto. Sin galería o sin visor, el enlace sigue a la página configurada; el botón
      (sin página) se oculta.
    */
    var guide = container.querySelector('[data-md-guia-index]');
    if (guide) {
      var gallery = document.querySelector('.md-producto-galeria[data-product-id="' + productId + '"]');
      var expand = gallery ? gallery.querySelector('.md-producto-galeria__expand') : null;
      var thumb = gallery
        ? gallery.querySelector('.md-producto-galeria__thumb[data-index="' + guide.dataset.mdGuiaIndex + '"]')
        : null;

      if (expand) {
        guide.addEventListener('click', function (e) {
          e.preventDefault();
          if (thumb) thumb.click();
          expand.click();
        });
      } else if (guide.tagName === 'BUTTON') {
        guide.hidden = true;
      }
    }

    /* Guía de tallas genérica: imagen de los ajustes en un diálogo propio de la sección */
    var guideDialogBtn = container.querySelector('[data-md-guia-dialogo]');
    var guideDialog = container.querySelector('.md-producto-compra__guia');
    if (guideDialogBtn && guideDialog && typeof guideDialog.showModal === 'function') {
      guideDialogBtn.addEventListener('click', function () {
        if (!guideDialog.open) guideDialog.showModal();
      });
      guideDialog.addEventListener('click', function (e) {
        if (e.target === guideDialog || e.target.closest('[data-md-guia-cerrar]')) guideDialog.close();
      });
    } else if (guideDialogBtn) {
      guideDialogBtn.hidden = true;
    }

    cleanups.set(container, function () {
      container.removeEventListener(VARIANT_EVENT, onProductSelect);
    });
  }

  function destroySection(container) {
    var cleanup = cleanups.get(container);
    if (!cleanup) return;
    cleanup();
    cleanups.delete(container);
    delete container.dataset.mdInit;
  }

  var sections = document.querySelectorAll(ROOT);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) destroySection(section);
  });
})();
